import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApprovalHistoryTablesEnum } from '@app/enums';

@Injectable()
export class ApprovalHistoryService {
	endpointBase = '/api/approvals-history';

	constructor(private readonly http: HttpClient) {}

	getApprovalHistory(entityId: number, entityTable: ApprovalHistoryTablesEnum): Observable<any> {
		return this.http.get(this.endpointBase, { params: { EntityId: entityId.toString(), EntityTable: entityTable.toString() } });
	}
}
